import { USERS_ADMIN } from '../constants/actionTypes';

const initial = { items: [], total: 0, loading: false, error: null };

export default function usersAdminReducer(state = initial, action) {
  switch (action.type) {
    case USERS_ADMIN.LIST_REQUEST: return { ...state, loading: true, error: null };
    case USERS_ADMIN.LIST_SUCCESS: return { ...state, loading: false, items: action.payload.items, total: action.payload.total };
    case USERS_ADMIN.LIST_FAILURE: return { ...state, loading: false, error: action.payload };
    case USERS_ADMIN.UPDATE:       return { ...state, items: state.items.map(u => u._id === action.payload._id ? action.payload : u) };
    case USERS_ADMIN.REMOVE:       return { ...state, items: state.items.filter(u => u._id !== action.payload) };
    default: return state;
  }
}
